const isDefined = variable => typeof variable !== 'undefined' && variable !== null;

export const buildCssVar = (name, ...defaults) => {
  return `${name}: ${defaults.find(isDefined)};`;
};
